// ── 类型定义（两端完全相同）──────────────────────────────────────

export type Template = {
  certificate: string[];
  created_at: number;
  description: string;
  file_num: number;
  files: TemplateFile[];
  id: string;
  must_realname: boolean;
  title: string;
  uid: string;
  updated_at: number;
  send: SendInfo;
  preview_url: string;
  /** 是否已转入永久存储（云空间） */
  saved?: boolean;
};

export type CosUploadedFileRef = {
  name: string;
  path: string;
};

export type UploadForm = {
  title: string;
  description: string;
  must_realname: boolean;
  files: CosUploadedFileRef[];
  certificate: CosUploadedFileRef[];
};

export type UpdateForm = {
  title: string;
  description: string;
  must_realname: boolean;
  certificate: CosUploadedFileRef[];
};

export type TemplateFile = {
  file_name: string;
  file_path: string;
  file_sha256: string;
  file_size: number;
  id: string;
  meta_info: MetaInfo;
  template_id: string;
  uid: string;
};

export type MetaInfo = {
  file_type: string;
  layer_num: number;
  layer_info: LayerInfo[];
  preview: string;
  pixel: number[];
};

export type LayerInfo = {
  layer_title: string;
  type: "layer" | "group";
  content: LayerInfo[];
};

export type SendInfo = {
  id: number;
  send_id: string;
  is_received: boolean;
  received_at: number;
  expire_at: number;
  created_at: number;
  mask_status: number;
};

export type SendRecord = {
  id: number;
  created_at: number;
  expire_at: number;
  is_received: boolean;
  received_at: number;
  receiver_uid: string;
  is_restricted: boolean;
};

export type SendReceiveHistoryType = "recive" | "send";

export type SendReceiveRecord = {
  id: number;
  received_at: number;
  receiver_uid: string;
  send_id: string;
  template_id: number;
  title: string;
  uid: string;
  is_received: boolean;
  mask_status: number;
  created_at: number;
};

/** 查标任务状态：0=处理中，1=已完成，2=失败 */
export enum DecodeTemplateStatus {
  Processing = 0,
  Completed = 1,
  Failed = 2,
}

export type DecodeTemplateRecord = {
  created_at: number;
  decode_id: string;
  error_msg: string;
  file_name: string;
  id: number;
  send_ids: number[];
  status: DecodeTemplateStatus | number;
  uid: string;
  updated_at: number;
};

export type DecodeTemplateListQuery = {
  page?: number;
  page_size?: number;
  file_name?: string;
  decode_id?: string;
  status?: DecodeTemplateStatus | number;
};

export type TraceDecodeResult = {
  template_id: number;
  template_title: string;
  uid: string;
  receiver_uid: string;
  send_at: number;
  received_at: number;
};

export interface AsyncDecodeResponse {
  error?: string;
  wait: boolean;
  async_id: string;
}

export interface UseStatisticsItem {
  uid: string;
  send_count: number;
  receive_count: number;
}
